<template>
    <div id="app">
        <!-- 최상위 컴포넌트 내용 -->
        <router-view></router-view> <!-- 라우터 쓸 때 -->
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
/* 전역 스타일 */
</style>
